/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
author: Coffeek (https://sketchfab.com/coffe0wolf)
license: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
source: https://sketchfab.com/3d-models/meat-fdcbd368e9454f559364a4ee794453a9
title: Meat
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { MilkModel } from "./MilkModel";

export function MeatModel(props) {
  const { nodes, materials } = useGLTF("../assets/models/meat/scene.glb");

  const position = props.meatPosition;

  return (
    <group
      {...props}
      dispose={null}
      scale={[1.3, 1.3, 1.3]}
      position={position}>
      <group rotation={[-Math.PI / 2, 0, 0]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_2.geometry}
          material={materials.first}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_3.geometry}
          material={materials.main}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_4.geometry}
          material={materials.second}
        />
        {/* <MilkModel position={[2, -2, -0.5]} /> */}
      </group>
    </group>
  );
}

useGLTF.preload("../assets/models/meat/scene.glb");
